// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake"}[chunkId] + "." + {"102":"b75fb5a3","133":"cbe14c70"}[chunkId] + ".chunk.js";
};